import React from 'react';
import { connect } from 'react-redux';
import { getListData } from 'helpers/agendaHelpers';

import render from './CalendarRender';
import CalendarCell from './CalendarCell';
import styles from './styles.module.scss';

export class Calendar extends React.Component {
  static defaultProps = {
    render,
  };

  dateCellRender = day => {
    const { filters, activityTypes, data, date } = this.props;
    if (day.month() !== date.month()) {
      return <div className={styles.events__none} />;
    }
    const listData = getListData(day, data, filters);
    if (!listData.length) {
      return null;
    }
    return (
      <ul className={styles.events}>
        {listData.map((item, i) =>
          <CalendarCell activityTypes={activityTypes} key={item.key || i} {...item} />)}
      </ul>
    );
  }

  render () {
    const { render: Render, activityTypes, ...nextProps } = this.props;
    const { dateCellRender } = this;
    const props = {
      ...nextProps,
      activityTypes,
      dateCellRender,
    };

    if (activityTypes.length) return <Render {...props} />;
    return null;
  }
}

const mapStateToProps = ({ admin: { activities: { list } } }) => ({
  activityTypes: list,
});

export default connect(mapStateToProps)(Calendar);



// WEBPACK FOOTER //
// ./src/components/Agenda/Calendar/index.js